import { render, staticRenderFns } from "./realname-approval-detail.vue?vue&type=template&id=5bc6cbb6&scoped=true"
import script from "./realname-approval-detail.vue?vue&type=script&lang=js"
export * from "./realname-approval-detail.vue?vue&type=script&lang=js"
import style0 from "./realname-approval-detail.vue?vue&type=style&index=0&id=5bc6cbb6&prod&lang=less&scoped=true"
import style1 from "./realname-approval-detail.vue?vue&type=style&index=1&id=5bc6cbb6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc6cbb6",
  null
  
)

export default component.exports